import React from 'react'
import { BodyText, Link } from '@paypalcorp/pp-react'
import { interpolate } from 'ppbl/utils/string-helper'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { weekDays, infoTextConstants } from 'ppbl/utils/constants'
import './styles.css'

const InfoText: React.FC = () => {

  const phoneNumber = infoTextConstants.phoneNumber.contact
  const helpText = interpolate(getLocalizedText('components.infoText.helpText'), {
    phoneNumber: (
      <Link
        href={infoTextConstants.phoneNumber.tel}
        size="md"
        secondary
      >
        {phoneNumber}
      </Link>
    ),
  })
  const hoursText = interpolate(getLocalizedText('components.infoText.hoursText'), {
    startDay: weekDays.STARTDAY_MONDAY,
    endDay: weekDays.ENDDAY_FRIDAY,
  })

  return (
    <div className='infoTxt'>
      <BodyText>{helpText}</BodyText>
      <BodyText>{hoursText}</BodyText>
    </div>
  )
}

export default InfoText